import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import SuperAdminSideNavbar from './helpers/superadminSideNavbar';
import noDataImage from "../assets/nodata.png";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faBookmark, faUser } from '@fortawesome/free-solid-svg-icons';
const SavedPromptsList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [statusFilter, setStatusFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const usersPerPage = 9;

  const fetchUsers = async (status = 'All') => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallsavedprompts`);
      setUsers(response.data);
      setFilteredUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(statusFilter);
  }, [statusFilter]);

  useEffect(() => {
    const lowerSearch = searchTerm.toLowerCase();
    const results = users.filter((user) =>
      user.UserName.toLowerCase().includes(lowerSearch) ||
      user.Email.toLowerCase().includes(lowerSearch)
    );
    setFilteredUsers(results);
    setCurrentPage(0); // Reset page when search changes
  }, [searchTerm, users]);


  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * usersPerPage;
  const currentUsers = filteredUsers.slice(offset, offset + usersPerPage);
  const pageCount = Math.ceil(filteredUsers.length / usersPerPage);

  return (
    <SuperAdminSideNavbar>
    <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
    <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ border: 'none', backgroundColor: '#fff' }}>
<h5 className="welcome-text mb-0" style={{ fontSize: '20px', color: '#2e3192' }}>Saved Prompts List</h5>

<div className="d-flex align-items-center gap-2">
  <input
              type="text"
              className="form-control"
              style={{ minWidth: '300px' }}
              placeholder="Search by name or email"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
</div>
</div>

      <hr />
      <div className="container mt-5">
        {loading ? (
          <div className="spinner"></div>
        ) : filteredUsers.length === 0 ? (
          <div style={{ textAlign: 'center' }}>
            <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
            <p style={{ color: '#2e3192', fontSize: '20px' }}>No users found</p>
          </div>
        ) : (
          <>
            <div className="row">
            {currentUsers.map((user) => (
  <div key={user.UserID} className="col-md-4 mb-4">
   <div className="card" style={{ height: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
        <div className="card-body">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-fullname-${user.UserID}`}>Full Name</Tooltip>}
        >
          <p className="card-title">
            <FontAwesomeIcon icon={faUser} className="me-2" style={{ color: '#2E3192' }} />
            {user.UserName}
          </p>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-email-${user.UserID}`}>Email</Tooltip>}
        >
          <p className="card-text">
            <FontAwesomeIcon icon={faEnvelope} className="me-2" style={{ color: '#2E3192' }} />
            {user.Email}
          </p>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-subscription-${user.UserID}`}> Prompt</Tooltip>}
        >
          <p className="card-text">
            <FontAwesomeIcon icon={faBookmark} className="me-2" style={{ color: '#2E3192' }} />
            {user.Promptdata}
          </p>
        </OverlayTrigger>

      
      </div>
    </div>
  </div>
))}

            </div>
            <div className="d-flex justify-content-center mt-4">
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </>
        )}
      </div>
    </div>
  </SuperAdminSideNavbar>
  );
};

export default SavedPromptsList;
